import axios, { fetchPostNoAction } from '@/utils/request'

// vin上传
export function scanner(params = {}, opinion = {}) {
  return axios.post('scanner?action=/vinByOpenApi/scanner', params, opinion)
}
// 零件号扫描
export function scannerPartNumber(params = {}, opinion = {}) {
  return axios.post('scanner?action=/vinByOpenApi/scannerPartNumber', params, opinion)
}
export function get(params = {}) {
  return fetchPostNoAction('/get', params)
}
export function sendSms(params = {}) {
  return fetchPostNoAction('/weChat/sendSms', params)
}
export function phoneLogin(params = {}) {
  return fetchPostNoAction('/weChat/phoneLogin', params)
}
